"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBackendVersion = getBackendVersion;
const http_helpers_1 = require("../../common/api/http-helpers");
const getApiUrl_1 = require("../../common/api/utils/getApiUrl");
const HTTPClient_1 = require("../../common/api/HTTPClient");
async function getBackendVersion() {
    try {
        const response = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)('/v1/version'),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return response;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return undefined;
    }
}
